import { render, staticRenderFns } from "./courses-details.vue?vue&type=template&id=7f113c2c&scoped=true&"
import script from "./courses-details.ts?vue&type=script&lang=ts&"
export * from "./courses-details.ts?vue&type=script&lang=ts&"
import style0 from "./courses-details.scss?vue&type=style&index=0&id=7f113c2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f113c2c",
  null
  
)

export default component.exports